import { Component, ChangeDetectorRef, ViewChild, AfterViewInit, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { SwalComponent, SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2';
import packageJson from '../../../../package.json';

import { ErrorsB2C } from 'src/app/models';
import { FsessionService } from 'src/app/servicios/session/fsession.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login-failed',
    templateUrl: './login-failed.component.html',
    styleUrls: ['./login-failed.component.scss'],
    standalone: false
})
export class LoginFailedComponent implements AfterViewInit {
  private fse = inject(FsessionService);
  private changeDetectorRef = inject(ChangeDetectorRef);
  authService = inject(MsalService);
  private router = inject(Router);
  swalTargets = inject(SwalPortalTargets);


  @ViewChild("errorAlert") aboutSwal: SwalComponent;

  ErrorMessage: string;
  titleMessage: string;
  error_B2C_User_Cancellation = ErrorsB2C.B2C_User_Cancellation;
  entorno = environment.entorno;
  version: string = packageJson.version;

  ngAfterViewInit() {
    this.error();

  }

  /**
   * Funcion para el manejo de errores
   */
  error() {

    let error = this.fse.optenerValor('errorB2C');
    /**
     * solo si el error es diferente al de "correo incorrecto al intentar actualizar password", 
     * validamos la sesión
     */
    if ( error !== ErrorsB2C['B2C-User-Email-Invalid'] ) this.validateSession();
    let restorePass =  JSON.parse(this.fse.optenerValor('restorePass'));


    if(error){
      this.titleMessage = 'error';

      switch (error){
        case ErrorsB2C.B2C_User_Cancellation:
          this.ErrorMessage = error;
          this.restart();
        break;

        case ErrorsB2C['B2C-User-No-Oid']:
          this.ErrorMessage = "B2C-User-No-Oid";
        break;

        case ErrorsB2C['B2C-User-No-Permission']:
          this.ErrorMessage = "B2C-User-No-Permission";
        break;

        case ErrorsB2C['B2C-Server-Failed']:
          this.ErrorMessage = "B2C-Server-Failed";
        break;

        case ErrorsB2C['B2C-User-Email-Invalid']:
          this.ErrorMessage = "B2C-User-Email-Invalid";
        break;

        case ErrorsB2C['B2C-Environment-Forbidden']:
          this.ErrorMessage = "B2C-Environment-Forbidden";
        break;

        case ErrorsB2C['B2C-Environment-lapsed']:
          this.ErrorMessage = "B2C-Environment-lapsed";
        break;
  
        default:
          this.validateSession();
          if(restorePass){
            this.titleMessage = 'operacionExitosa';
            this.ErrorMessage = 'restaurarConstraseña';
            setTimeout(() => this.fse.deleteVariable('restorePass'), 1000);
          }else{
            this.ErrorMessage = "errorAlValidarUsuario";
          }
        break;
      }
    }else{
      const error_acceso_enviroment = JSON.parse(this.fse.optenerValor('error_acceso_enviroment'));
      if (error_acceso_enviroment) {
        this.titleMessage = 'error';
        this.ErrorMessage = 'B2C-Environment-lapsed';
      }
      else {
        setTimeout(() => {
          this.titleMessage = 'edicion_usuario';
          this.ErrorMessage = 'fail_edicion_usuario';

          this.restart();
          this.changeDetectorRef.detectChanges(); 
          return;
        }, 1000);
      }
    }

    this.aboutSwal.fire();
  }

  /**
   * Ir a la url por defecto
   */
  restart(){

    const error_acceso_enviroment = JSON.parse(this.fse.optenerValor('error_acceso_enviroment'));
    if (error_acceso_enviroment) {
      this.fse.deleteVariable('error_acceso_enviroment');
      this.closeSession();
    }
    else {
      const error = this.fse.optenerValor('errorB2C');
      if ( error === ErrorsB2C['B2C-User-Email-Invalid'] ) this.fse.deleteVariable('errorB2C');
      window.location.replace('/');
    }

  }

  /**
   * Valida si tiene un cuenta activa
   * @returns retorna a la primera ruta que tenga permiso
   */
  validateSession(){
    if ( this.authService.instance.getAllAccounts().length > 0 ) {
      this.restart();
      this.ErrorMessage = ErrorsB2C.B2C_User_Cancellation;
      return;
    }
  }

  /**
   * Cierra la sesion actual del usuario
   */
  closeSession() {
    this.fse.closeSession();
    this.authService.logoutRedirect().subscribe(() => {
      this.router.navigate(["/"]);
    });
  }
}
